import { Box, Flex, Spinner } from "@chakra-ui/react"
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"
import { lazy, Suspense } from "react"

const Sidebar = lazy(() => import("../components/Common/Sidebar"))
const UserMenu = lazy(() => import("../components/Common/UserMenu"))
const ThemeToggleButton = lazy(() => import("../utils/ThemeToggleButton"))

import useAuth, { isLoggedIn } from "../hooks/useAuth"

export const Route = createFileRoute("/_layout")({
  component: Layout,
  beforeLoad: async () => {
    if (!isLoggedIn()) {
      throw redirect({ to: "/login" })
    }
  },
})

function Layout() {
  const { isLoading } = useAuth()

  return (
    <Suspense fallback={<Spinner size="xl" color="main.accent" />}>
      <Flex
        direction={{ base: "column", md: "row" }}
        h="100vh"
        w="100%"
        overflow="hidden"
        position="relative"
      >
        {/* Sidebar — займає фіксовану ширину */}
        <Sidebar />

        {/* Основний контент */}
        <Box
          flex="1"
          overflowX="auto"
          overflowY="auto"
          px={{ base: 4, md: "15px" }}
          py={{ base: 4, md: 6 }}
          mt="60px"
          position="relative"
          zIndex="1"
        >
          {isLoading ? (
            <Flex justify="center" align="center" height="100vh" width="full">
              <Spinner size="xl" color="main.accent" />
            </Flex>
          ) : (
            <Outlet />
          )}
        </Box>

        <Box
          display={{ base: "none", md: "block" }}
          position="fixed"
          top={4}
          right="68px" // розміщуємо лівіше від кнопки користувача з невеликим відступом
          zIndex="1000"
        >
          <ThemeToggleButton />
        </Box>
        <UserMenu />
      </Flex>
    </Suspense>
  )
}
